module.exports = __webpack_public_path__ + "static/media/storage-pin.788e8551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/svg/icons/storage-pin.svg
// module id = 2030
// module chunks = 0